import React from "react";
import classNames from "classnames";
import { useDrag } from "react-dnd";
import tinycolor from "tinycolor2";
import { FormGroup, ControlLabel, FormControl } from "react-bootstrap";

import Address from "../../shared/Address";
import styles from "./AvailableAppointments.css";

export const DraggableType = "appointment";

const makeStylec = ({ color }) =>
  !color
    ? null
    : {
        backgroundColor: color,
        borderColor: tinycolor(color).darken(40),
        color: tinycolor(color).getBrightness() < 150 ? "#fff" : "#000",
      };

const makeStyle = ({ assignedToResource }) => {
  return assignedToResource && assignedToResource.calendarColor
    ? {
        backgroundColor: assignedToResource.calendarColor,
        borderColor: tinycolor(assignedToResource.calendarColor).darken(40),
        color:
          tinycolor(assignedToResource.calendarColor).getBrightness() < 150
            ? "#fff"
            : "#000",
      }
    : null;
};

const Appointment = ({ appointment, onClick, color }) => {
  const [, drag] = useDrag({
    item: { appointmentId: appointment.id, appointment, type: DraggableType },
  });
  return (
    <div
      className={classNames(styles.appointment)}
      onDoubleClick={onClick}
      ref={drag}
      style={makeStylec(appointment)}
    >
      <div>
        <div style={makeStyle(appointment)}>
          <h5
            style={{
              textAlign: "left",
              padding: "6px 8px",
              fontSize: "16px",
              fontFamily: "var(--font-family-Fira-Condensed)",
              margin: 0,
            }}
          >
            <b>{appointment.name}</b>
          </h5>
        </div>
        <div
          className={styles.appointmentHeader}
          style={{ padding: "0px 8px 8px 8px" }}
        >
          {appointment.officeName && appointment.name !== "" && (
            <FormGroup className={styles.dataValuePair}>
              <ControlLabel className={styles.dataValuePairLabel}>
                Datasheet Name
              </ControlLabel>
              <FormControl.Static
                className={styles.dataValuePairValue}
                componentClass={"div"}
              >
                {appointment.name}
              </FormControl.Static>
            </FormGroup>
          )}

          {!appointment.officeName && (
            <FormGroup className={styles.dataValuePair}>
              <ControlLabel className={styles.dataValuePairLabel}>
                Customer Name
              </ControlLabel>
              <FormControl.Static
                className={styles.dataValuePairValue}
                componentClass={"div"}
              >
                {appointment.name}
              </FormControl.Static>
            </FormGroup>
          )}

          {appointment.officeName && (
            <FormGroup className={styles.dataValuePair}>
              <ControlLabel className={styles.dataValuePairLabel}>
                Office
              </ControlLabel>
              <FormControl.Static
                className={styles.dataValuePairValue}
                componentClass={"div"}
              >
                {appointment.officeName}
              </FormControl.Static>
            </FormGroup>
          )}

          {appointment.office && (
            <FormGroup className={styles.dataValuePair}>
              <ControlLabel className={styles.dataValuePairLabel}>
                Office
              </ControlLabel>
              <FormControl.Static
                className={styles.dataValuePairValue}
                componentClass={"div"}
              >
                {appointment.office.name}
              </FormControl.Static>
            </FormGroup>
          )}

          {appointment.assignedToResource && (
            <FormGroup className={styles.dataValuePair}>
              <ControlLabel className={styles.dataValuePairLabel}>
                Sales Person
              </ControlLabel>
              <FormControl.Static
                className={styles.dataValuePairValue}
                componentClass={"div"}
              >
                {appointment.assignedToResource.firstName}{" "}
                {appointment.assignedToResource.lastName}
              </FormControl.Static>
            </FormGroup>
          )}

          {appointment.customer && appointment.customer.name !== "" && (
            <FormGroup className={styles.dataValuePair}>
              <ControlLabel className={styles.dataValuePairLabel}>
                Customer
              </ControlLabel>
              <FormControl.Static
                className={styles.dataValuePairValue}
                componentClass={"div"}
              >
                {appointment.customer.name}
              </FormControl.Static>
            </FormGroup>
          )}

          {appointment.customer && appointment.customer.phoneNumber !== "" && (
            <FormGroup className={styles.dataValuePair}>
              <ControlLabel className={styles.dataValuePairLabel}>
                Phone
              </ControlLabel>
              <FormControl.Static
                className={styles.dataValuePairValue}
                componentClass={"div"}
              >
                {appointment.customer.phoneNumber}
              </FormControl.Static>
            </FormGroup>
          )}
        </div>
      </div>
    </div>
  );
};

export default Appointment;
